import { cn } from '@cuspar/ui';
import React from 'react';
import { i18nNumber } from '../../i18n';

export const PriceGadget: React.FC<{ price: number; currency: string; className?: string }> = ({ price, currency, className }) => {
  return (
    <span className={cn('inline-flex gap-1', className)}>
      <span className='uppercase'>{currency}</span>
      <span>{i18nNumber(price / 100)}</span>
    </span>
  );
};

export const PriceToString = (price: number, currency: string) => {
  return `${currency.toUpperCase()} ${i18nNumber(price / 100)}`;
};
